import faIR, { Locale } from 'dayjs/locale/fa';

const FarsiLocale: Locale = {
    ...faIR,
    weekdaysShort: ['یک', 'دو', 'سه', 'چهار', 'پنج', 'جم', 'شن'],
};

export default FarsiLocale;
